import { createSlice } from '@reduxjs/toolkit';

const securitySlice = createSlice({
  name: 'security',
  initialState: {
    user: null
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setCompany(state, action) {
      state.company = action.payload;
    }
  }
});

const { actions, reducer } = securitySlice;

export const { setUser, setCompany } = actions;
export default reducer;
